module.exports = __webpack_public_path__ + "img/bg_multitle_down.0fee0a5f.png";